module.exports = __webpack_public_path__ + "static/media/menu_relatorio_consulta.2632acd3.png";